import { Typography } from "@mui/material";
import { ConfirmDialog } from "../common/ConfirmDialog";

interface BulkSignConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    selectedCount: number;
}

export const BulkSignConfirmationDialog: React.FC<BulkSignConfirmationDialogProps> = ({
    open,
    onClose,
    onConfirm,
    selectedCount
}) => {
    return (
        <ConfirmDialog
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Вы уверены?"
            content={
                <Typography>
                    После подтверждения отменить подписание будет невозможно.
                </Typography>
            }
        />
    );
};
